export default __webpack_public_path__ + "static/media/Wrinkle_Map.83d0b514.jpg";